"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const summaryCard_1 = __importDefault(require("../summaryCard/summaryCard"));
const qualityAssuranceConstants_1 = require("../../features/qualityAssurance/qualityAssuranceConstants");
const auditUtils_1 = require("./auditUtils");
const communicationBoxUtils_1 = __importDefault(require("../communicationBox/communicationBoxUtils"));
const styles_1 = __importDefault(require("../../styles/styles"));
const utils_1 = require("../../utils/utils");
const filterCallRecordConstants_1 = require("../filterCallRecord/filterCallRecordConstants");
const auditConstants_1 = require("./auditConstants");
const CallDetailRecordAuditSummary = ({ callDetailRecordAudit, callRecord, }) => {
    const callTypeKey = callRecord.call_type;
    const callType = qualityAssuranceConstants_1.CALL_TYPE_STATUS[callTypeKey];
    const duration = communicationBoxUtils_1.default(callRecord.billsec, true);
    const listItem = [];
    if (callDetailRecordAudit) {
        const tag = auditUtils_1.findChoiceByValue(auditConstants_1.TAG_CHOICES, callDetailRecordAudit.tag);
        const reviewStatus = auditUtils_1.findChoiceByValue(filterCallRecordConstants_1.STATUS_CHOICES, Number(callRecord.review_status));
        const reasonForDelayedPayment = auditUtils_1.getReasonForDelayedPayment(callRecord.call_type, callDetailRecordAudit);
        listItem.push({ title: 'Customer Complaint/Enquiry Tag', description: tag ? tag.label : '' }, {
            title: 'Reason For Delayed Payment',
            description: reasonForDelayedPayment ? reasonForDelayedPayment.label : 'N/A',
        }, { title: 'Review Status', description: reviewStatus ? reviewStatus.label : '' });
        Object.entries(callDetailRecordAudit.score_summary).forEach(([key, value]) => {
            // Initialize a new ListItem object with the current key as the title
            // and the initial description as 0
            const scoreField = { title: key, description: '' };
            if (typeof value === 'object') {
                // Map through the entries of the value object and create a new ListItem
                // object for each child key and value
                scoreField.children = Object.entries(value).map(([childKey, childValue]) => ({
                    title: childKey,
                    description: childValue,
                }));
                // Get the total score of all the child items
                const totalChildScore = scoreField.children.reduce((a, b) => a + b.description, 0);
                // Calculate the average child score and round it to two decimal places
                const childCount = Math.round((totalChildScore / Object.keys(value).length) * 100) / 100;
                // Set the description of the parent item to the average child score as a percentage
                scoreField.description = `${childCount}%`;
            }
            else {
                // If the value is not an object, set the description of the parent item to the value
                scoreField.description = `${value}`; //  Cast value to a string
            }
            // Add the parent item to the array
            listItem.push(scoreField);
        });
    }
    const listItem2 = [
        { title: 'Call Record ID', description: callRecord.id },
        { title: 'Schedule ID', description: callRecord.schedule_id || '' },
        { title: 'Schedule Notes', description: callRecord.schedule_notes || '' },
        { title: 'External ID', description: callRecord.external_id || '' },
        { title: 'External ID Type', description: callRecord.external_id_type_display },
        { title: 'Officer', description: callRecord.officer || '' },
        { title: 'Call Type', description: callType },
        { title: 'Duration', description: duration },
        { title: 'Disposition', description: callRecord.disposition },
        { title: 'Source', description: callRecord.src },
        { title: 'Destination', description: callRecord.destination },
        { title: 'Call Time', description: utils_1.formatDateString(callRecord.calldate) },
    ];
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.flexWrap, styles_1.default.flexOne] },
            react_1.default.createElement(summaryCard_1.default, { title: "Audit basic details", icon: "clipboard", listItems: listItem2 }),
            callDetailRecordAudit ? (react_1.default.createElement(summaryCard_1.default, { title: "Summary", icon: "scoreboard", listItems: listItem, subtitle: callDetailRecordAudit.comments })) : null)));
};
exports.default = CallDetailRecordAuditSummary;
